import { type HTMLAttributes, useState, useEffect, useRef } from "react";
import { type Control, useController } from "react-hook-form";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { classNames } from "../../../../utils/classNames";
import "../styles/index.css";

interface Props extends HTMLAttributes<HTMLInputElement> {
  control: Control;
  name: string;
  placeholder?: string;
  icon?: React.ReactElement;
  label?: string;
}

const TextField = ({
  control,
  name,
  placeholder,
  icon,
  label,
  ...elementAttributes
}: Props) => {
  const [isFocus, setIsFocus] = useState(false);
  const {
    field: { value = "", onChange, ref },
    fieldState: { error },
  } = useController({
    name,
    control,
    defaultValue: "",
  });

  const handleBlur = (e) => {
    const value = e.target.value;
    if (!!!value) {
      setIsFocus(false);
    } else {
      setIsFocus(true);
    }
  };

  return (
    <div className={tw`relative`}>
      <div className={tw`bg-[#EEF5F4] rounded-xl`}>
        <div
          className={tw`w-full my-2 text-left mt-2 flex items-center gap-4 p-4 relative`}
        >
          <div className={tw``}>{icon}</div>
          <div className={tw`flex-1 relative pt-2`}>
            <input
              {...elementAttributes}
              placeholder={placeholder}
              defaultValue={value}
              id={name}
              className={classNames(
                `${tw`w-full bg-transparent outline-none focus:ring-0`} auth-login-input`
              )}
              onFocus={() => setIsFocus(true)}
              onChange={(e) => {
                onChange(e.target.value);
                setIsFocus(true);
              }}
              onBlur={handleBlur}
              ref={ref}
            />
            <label
              htmlFor={name}
              className={classNames(
                isFocus
                  ? tw`-translate-y-[125%] text-normal text-gray-500`
                  : tw`-translate-y-1/2`,
                tw`text-gray-600 cursor-text  absolute top-1/2  left-0 transition-all duration-400 ease-in-out`
              )}
            >
              {label}
            </label>
          </div>
        </div>
      </div>
      {error && (
        <p className={tw`absolute bottom-0 ml-14 text-red-500 text-xs`}>
          {error?.message}
        </p>
      )}
    </div>
  );
};

export default TextField;
